import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/layout/Navbar';
import Footer from '../../components/layout/Footer';
import api from '../../utils/api';

const StarRow = ({ n = 5 }) => (
  <span style={{color:'#f59e0b',fontSize:'0.9rem'}}>{'★'.repeat(n)}</span>
);

function HeroSection() {
  return (
    <section style={{background:'linear-gradient(150deg,#edfaf3 0%,#f5fdf9 60%,#fff 100%)',padding:'72px 0 60px',overflow:'hidden',position:'relative'}}>
      {/* Background blobs */}
      <div style={{position:'absolute',width:320,height:320,borderRadius:'50%',background:'radial-gradient(circle,rgba(34,201,127,0.12),transparent)',top:-80,right:'10%',pointerEvents:'none'}}/>
      <div style={{position:'absolute',width:200,height:200,borderRadius:'50%',background:'radial-gradient(circle,rgba(34,201,127,0.08),transparent)',bottom:0,left:'5%',pointerEvents:'none'}}/>
      <div className="container">
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:48,alignItems:'center'}}>
          {/* Left */}
          <div>
            <div style={{display:'inline-flex',alignItems:'center',gap:8,background:'#fff',border:'1.5px solid #c8f5e0',borderRadius:20,padding:'6px 14px',marginBottom:24}}>
              <span style={{width:7,height:7,borderRadius:'50%',background:'#22c97f',display:'inline-block'}}/>
              <span style={{fontSize:'0.8rem',fontWeight:700,color:'#0d6e4f'}}>Live tutors available now</span>
            </div>
            <h1 style={{marginBottom:20,lineHeight:1.15}}>
              Expert tutoring<br/>
              <span style={{color:'#22c97f'}}>without the price tag</span>
            </h1>
            <p style={{fontSize:'1.05rem',marginBottom:32,maxWidth:440,color:'#3d6650'}}>
              Connect with qualified, vetted tutors for just <strong style={{color:'#052e1c'}}>£8/hr</strong> or <strong style={{color:'#052e1c'}}>$10/hr</strong>. No subscriptions, no surprises — just great learning.
            </p>
            <div style={{display:'flex',gap:12,flexWrap:'wrap',marginBottom:32}}>
              <Link to="/find-tutors" className="btn btn-primary btn-lg">Find a tutor</Link>
              <Link to="/how-it-works" className="btn btn-secondary btn-lg">How it works</Link>
            </div>
            <div style={{display:'flex',gap:24,flexWrap:'wrap'}}>
              {[['🎓','Fully vetted tutors'],['💳','No hidden fees'],['⭐','Rated by parents']].map(([icon,text])=>(
                <div key={text} style={{display:'flex',alignItems:'center',gap:7,fontSize:'0.85rem',fontWeight:600,color:'#3d6650'}}>
                  <span>{icon}</span>{text}
                </div>
              ))}
            </div>
          </div>
          {/* Right — desk illustration */}
          <div style={{display:'flex',justifyContent:'center'}}>
            <div style={{
              width:340, height:340, borderRadius:'50% 40% 50% 40% / 40% 50% 40% 50%',
              background:'linear-gradient(135deg,#edfaf3,#c8f5e0)',
              display:'flex', alignItems:'center', justifyContent:'center',
              position:'relative', boxShadow:'0 20px 60px rgba(34,201,127,0.2)'
            }}>
              <svg viewBox="0 0 280 260" width="260" height="240" xmlns="http://www.w3.org/2000/svg">
                {/* Desk */}
                <rect x="20" y="190" width="240" height="14" rx="4" fill="#16a566" opacity="0.3"/>
                {/* Laptop base */}
                <rect x="60" y="148" width="160" height="44" rx="6" fill="#0a4a35"/>
                {/* Screen */}
                <rect x="70" y="88" width="140" height="64" rx="8" fill="#0d6e4f"/>
                <rect x="76" y="94" width="128" height="52" rx="5" fill="#052e1c"/>
                {/* Screen content — chart */}
                <polyline points="82,134 100,118 120,126 142,108 162,114 192,100" fill="none" stroke="#22c97f" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="100" cy="118" r="3" fill="#22c97f"/>
                <circle cx="142" cy="108" r="3" fill="#4ddba0"/>
                <circle cx="192" cy="100" r="3" fill="#22c97f"/>
                {/* Laptop hinge */}
                <rect x="120" y="150" width="40" height="5" rx="2" fill="#16a566" opacity="0.5"/>
                {/* Books stack */}
                <rect x="20" y="168" width="45" height="10" rx="3" fill="#22c97f" opacity="0.8"/>
                <rect x="22" y="160" width="40" height="10" rx="3" fill="#4ddba0" opacity="0.7"/>
                <rect x="25" y="152" width="35" height="10" rx="3" fill="#88ecc2" opacity="0.8"/>
                {/* Mug */}
                <rect x="215" y="162" width="28" height="30" rx="5" fill="#16a566" opacity="0.7"/>
                <path d="M243 172 Q256 172 256 177 Q256 182 243 182" fill="none" stroke="#16a566" strokeWidth="3" opacity="0.7"/>
                <rect x="219" y="166" width="20" height="4" rx="2" fill="#fff" opacity="0.4"/>
                {/* Plant */}
                <rect x="228" y="175" width="8" height="18" rx="2" fill="#0a4a35" opacity="0.5"/>
                <ellipse cx="232" cy="158" rx="16" ry="18" fill="#22c97f" opacity="0.3"/>
                <ellipse cx="222" cy="163" rx="10" ry="13" fill="#22c97f" opacity="0.4"/>
                <ellipse cx="242" cy="163" rx="10" ry="13" fill="#22c97f" opacity="0.4"/>
                {/* Notebook */}
                <rect x="68" y="170" width="50" height="22" rx="3" fill="#f5fdf9" opacity="0.9"/>
                <line x1="74" y1="177" x2="112" y2="177" stroke="#b8d4c4" strokeWidth="1.5"/>
                <line x1="74" y1="183" x2="108" y2="183" stroke="#b8d4c4" strokeWidth="1.5"/>
                {/* Sparkles */}
                <text x="175" y="82" fontSize="16" opacity="0.7">✦</text>
                <text x="48" y="96" fontSize="12" opacity="0.5">✦</text>
                <text x="200" y="148" fontSize="10" opacity="0.4">✦</text>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <style>{`@media(max-width:768px){section>div>div{grid-template-columns:1fr!important} section>div>div>div:last-child{display:none!important}}`}</style>
    </section>
  );
}

function StatsBar() {
  const stats = [['500+','Qualified tutors'],['£8','Per hour — always'],['4.9★','Average rating'],['UK & US','Two countries']];
  return (
    <div style={{background:'#052e1c',padding:'20px 0'}}>
      <div className="container">
        <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16}}>
          {stats.map(([val,label])=>(
            <div key={label} style={{textAlign:'center'}}>
              <div style={{fontSize:'1.4rem',fontWeight:800,color:'#22c97f'}}>{val}</div>
              <div style={{fontSize:'0.78rem',color:'rgba(255,255,255,0.55)',fontWeight:500}}>{label}</div>
            </div>
          ))}
        </div>
      </div>
      <style>{`@media(max-width:640px){div>div>div{grid-template-columns:repeat(2,1fr)!important}}`}</style>
    </div>
  );
}

function HowItWorksSnippet() {
  const steps = [
    { icon:'🔍', title:'Search tutors', desc:'Filter by subject, level, availability and DBS status.' },
    { icon:'📅', title:'Book a lesson', desc:'Request a slot — tutor confirms within 24 hours.' },
    { icon:'💳', title:'Pay from wallet', desc:'Top up your wallet once, book as many lessons as you need.' },
    { icon:'⭐', title:'Review & rebook', desc:'Sign off the lesson and leave a review. Simple.' },
  ];
  return (
    <section style={{padding:'72px 0',background:'#fff'}}>
      <div className="container">
        <div style={{textAlign:'center',marginBottom:48}}>
          <h2>How it works</h2>
          <p style={{maxWidth:480,margin:'12px auto 0',fontSize:'1rem'}}>Getting started takes less than 5 minutes.</p>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:24}}>
          {steps.map((s,i)=>(
            <div key={i} style={{textAlign:'center',padding:'28px 20px',borderRadius:16,border:'1.5px solid #deeee7',background:'#f5fdf9',position:'relative'}}>
              <div style={{position:'absolute',top:12,left:16,width:24,height:24,borderRadius:'50%',background:'#22c97f',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'0.72rem',fontWeight:800,color:'#fff'}}>{i+1}</div>
              <div style={{fontSize:'2rem',marginBottom:14}}>{s.icon}</div>
              <h3 style={{fontSize:'1rem',marginBottom:8}}>{s.title}</h3>
              <p style={{fontSize:'0.875rem',margin:0}}>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function SubjectsSection() {
  const subjects = ['Maths','English','Science','Biology','Chemistry','Physics','History','Geography','French','Spanish','Computing','Economics','Psychology','11+ Prep','A-Level'];
  return (
    <section style={{padding:'60px 0',background:'#edfaf3'}}>
      <div className="container">
        <h2 style={{textAlign:'center',marginBottom:32}}>Popular subjects</h2>
        <div style={{display:'flex',flexWrap:'wrap',gap:10,justifyContent:'center'}}>
          {subjects.map(s=>(
            <Link key={s} to={`/find-tutors?subject=${encodeURIComponent(s)}`}
              style={{padding:'9px 18px',background:'#fff',border:'1.5px solid #c8f5e0',borderRadius:20,fontWeight:600,fontSize:'0.875rem',color:'#0a4a35',textDecoration:'none',transition:'all 0.2s'}}
              onMouseOver={e=>{e.target.style.background='#22c97f';e.target.style.color='#fff';e.target.style.borderColor='#22c97f';}}
              onMouseOut={e=>{e.target.style.background='#fff';e.target.style.color='#0a4a35';e.target.style.borderColor='#c8f5e0';}}
            >{s}</Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function TestimonialsSection() {
  const reviews = [
    { name:'Sarah M.', text:'Found an amazing maths tutor for my son within minutes. He went from a D to a B in 6 weeks!', rating:5, subject:'GCSE Maths' },
    { name:'James T.', text:'The pricing is so fair. We\'ve been using Budget Tutor for 3 months now — absolutely brilliant service.', rating:5, subject:'A-Level Chemistry' },
    { name:'Priya K.', text:'My daughter was struggling with 11+ prep. The tutor was patient, thorough, and results speak for themselves.', rating:5, subject:'11+ Preparation' },
  ];
  return (
    <section style={{padding:'72px 0',background:'#fff'}}>
      <div className="container">
        <h2 style={{textAlign:'center',marginBottom:8}}>What parents say</h2>
        <p style={{textAlign:'center',marginBottom:40,color:'var(--ink-400)'}}>Real reviews from real families</p>
        <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(280px,1fr))',gap:20}}>
          {reviews.map((r,i)=>(
            <div key={i} className="card" style={{padding:24}}>
              <StarRow n={r.rating}/>
              <p style={{margin:'12px 0',fontSize:'0.9rem',fontStyle:'italic',color:'#3d6650'}}>"{r.text}"</p>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                <strong style={{fontSize:'0.85rem'}}>{r.name}</strong>
                <span className="badge badge-green">{r.subject}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTASection() {
  return (
    <section style={{padding:'72px 0',background:'linear-gradient(135deg,#052e1c,#0a4a35)'}}>
      <div className="container" style={{textAlign:'center'}}>
        <h2 style={{color:'#fff',marginBottom:12}}>Ready to find your perfect tutor?</h2>
        <p style={{color:'rgba(255,255,255,0.65)',fontSize:'1rem',marginBottom:32,maxWidth:440,margin:'0 auto 32px'}}>
          Join thousands of families already getting affordable, quality tutoring.
        </p>
        <div style={{display:'flex',gap:14,justifyContent:'center',flexWrap:'wrap'}}>
          <Link to="/register/parent" className="btn btn-primary btn-lg">Start as a parent</Link>
          <Link to="/become-a-tutor" className="btn btn-outline btn-lg" style={{color:'#fff',borderColor:'rgba(255,255,255,0.4)'}}>Become a tutor</Link>
        </div>
      </div>
    </section>
  );
}

export default function HomePage() {
  return (
    <div className="page-wrapper">
      <Navbar />
      <HeroSection />
      <StatsBar />
      <HowItWorksSnippet />
      <SubjectsSection />
      <TestimonialsSection />
      <CTASection />
      <Footer />
    </div>
  );
}
